import { requestSetDefaultPriorityGrid as postSetDefaultPriorityGrid } from '@/console/api/defaultPriorityGrid'
import { DefaultPriorityGridRequest, DefaultPriorityGridResponse } from '@/console/api/types'

/** LOGISPRD-15812 — 디폴트 센터 우선순위 일괄 반영. `api/defaultPriorityGrid.ts` 로 그대로 위임한다. */
export const requestSetDefaultPriorityGrid = (request: DefaultPriorityGridRequest): Promise<DefaultPriorityGridResponse> =>
  postSetDefaultPriorityGrid(request)
